import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import ProductrawDashboard from '../ProductrawDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function ProductrawPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < ProductrawDashboard />
    )

}